// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"c220e3d0","869":"a5c5a180"}[chunkId] + ".chunk.js";
};